export default "__VITE_ASSET__b37ce152__"